import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import moment from "moment";
import numeral from "numeral";

interface ShiftAtomJournalState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;
    meta: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
    ingredients: any[];
}

const state: ShiftAtomJournalState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: [],
    ingredients: [],
};

const initState: any = cloneDeep(state);

const GET_SHIFT_FACT_VDP = 'GET_SHIFT_FACT_VDP';
const GET_SCHEMA_FACT_VDP = 'GET_SCHEMA_FACT_VDP';
const GET_SHIFT_FACT_WASH = 'GET_SHIFT_FACT_WASH';


export const actions: ActionTree<ShiftAtomJournalState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(GET_SHIFT_FACT_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sja.id',
                  plan_id: 'sja.plan_id',
                  number: 'sacp.number',
                  product_name: 'pp.name',
                  clots_weight: 'sja.clots_weight',
                  quantity: 'sacpi.quantity',
                  palet_weight: 'sja.palet_weight',
                  recast: { $mul: ['sja.recast', 'vcnt.weight']},
                  acidity_1: 'sja.acidity_1',
                  acidity_2: 'sja.acidity_2',
                  acidity_3: 'sja.acidity_3',
                  acidity_4: 'sja.acidity_4',
                  release_name: 'vrg.name',
                  quality_name: 'vqp.name',
                  density_name: 'vd.name',
                  consitency_name: 'vc.name',
                  clots_device_weight: 'sja.clots_device_weight',
                  formed_date: "sja.formed_date",
                  load_pp_begin_date: "sja.load_pp_begin_date",
                  bottling_begin_date: "sja.bottling_begin_date",
                  bottling_end_date: "sja.bottling_end_date",
                  set_fan_date: "sja.set_fan_date",
                  ingredients: {
                    $array_agg: {
                      $obj: {
                        id: 'sjai.id',
                        ingredient_id: 'sjai.ingredient_id',
                        name: 'vi.name',
                        code: 'vi.code',
                        value: 'sjai.value',
                        shift_atom_batch_id: 'sab.id',
                        manufacturer: 'vm.name',
                        batch_datetime: 'b.datetime',
                        batch_number: 'b.batch_number',
                      }
                    }
                  }
                },
                from: 's:shift_journal_atom',
                from_as: 'sja',
                joins: [
                  {
                    join: 's:shift_atom_coock_plan',
                    type: 'left',
                    as:   'sacp',
                    on: {
                      $eq: ['sja.plan_id', 'sacp.id']
                    }
                  },
                  {
                    join: 's:produced_products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['sacp.product_id', 'pp.id']
                    }
                  },
                  {
                    join: 's:voc_release_gps',
                    type: 'left',
                    as:   'vrg',
                    on: {
                      $eq: ['sja.release_id', 'vrg.id']
                    }
                  },
                  {
                    join: 's:voc_quality_pps',
                    type: 'left',
                    as:   'vqp',
                    on: {
                      $eq: ['sja.quality_id', 'vqp.id']
                    }
                  },
                  {
                    join: 's:voc_densities',
                    type: 'left',
                    as:   'vd',
                    on: {
                      $eq: ['sja.density_id', 'vd.id']
                    }
                  },
                  {
                    join: 's:voc_consistencies',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['sja.consitency_id', 'vc.id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcnt',
                    on: {
                      $eq: ['sja.recast_container_id', 'vcnt.id']
                    }
                  },
                  {
                    join: 's:shift_journal_atom_ingredients',
                    type: 'left',
                    as:   'sjai',
                    on: {
                      $eq: ['sjai.journal_id', 'sja.id']
                    }
                  },
                  {
                    join: 's:voc_ingredients',
                    type: 'left',
                    as:   'vi',
                    on: {
                      $eq: ['sjai.ingredient_id', 'vi.id']
                    }
                  },
                  {
                    join: 's:shift_atom_batches',
                    type: 'left',
                    as:   'sab',
                    on: {
                      $eq: ['sab.journal_ingredient_id', 'sjai.id']
                    }
                  },
                  {
                    join: 's:batches',
                    type: 'left',
                    as:   'b',
                    on: {
                      $and: [
                        {$eq: ['b.id', 'sab.batch_id']},
                        {$eq: ['b.ingredient_id', 'vi.id']}
                      ]
                    }
                  },
                  {
                    join: 's:voc_manufacturers',
                    type: 'left',
                    as:   'vm',
                    on: {
                      $eq: ['vm.id', 'b.manufacturer_id']
                    }
                  },
                  {
                    join: {
                      columns: {
                        coock_plan_id: 'sacpi.coock_plan_id',
                        quantity: {$sum: 'sacpi.quantity'} 
                      },
                      from: 's:shift_atom_coock_plan_items',
                      from_as: 'sacpi',
                      groups: [
                        'sacpi.coock_plan_id'
                      ]
                    },
                    type: 'left',
                    as: 'sacpi',
                    on: { $eq: ['sacp.id', 'sacpi.coock_plan_id'] }
                  }
                ],
                order: [
                  {$asc: ['sacp.number']},
                ],
                groups: [
                  "sja.id",
                  'sacp.id',
                  'pp.name',
                  'vrg.name',
                  'vqp.name',
                  'vd.name',
                  'vc.name',
                  'sacpi.quantity',
                  'vcnt.weight'
                ],
                where: {
                  $and: [
                    {$eq: [`sacp.shift_id`, {$: documentId}]},
                    {$null: [`sacp.deleted_at`]}
                  ]
                }
              }),
              vm.$q(GET_SHIFT_FACT_WASH)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sjw.id',
                  number: 'spw.number',
                  product_name: 'vv.name',
                  wash_type: 'vwt.name',
                  water_volume: 'vvw.water_volume',
                  detergent_volume: 'vvw.detergent_volume',
                  detergent_concentration: 'vvw.detergent_concentration',
                  detergent_name: 'vd.name',
                  begin_datetime: 'sjw.begin_datetime',
                  end_datetime: 'sjw.end_datetime',
                },
                from: 's:shift_journal_washing',
                from_as: 'sjw',
                joins: [
                  {
                    join: 's:shift_plan_washing',
                    type: 'left',
                    as:   'spw',
                    on: {
                      $eq: ['sjw.plan_washing_id', 'spw.id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    as:   'vv',
                    on: {
                      $eq: ['vv.id', 'spw.equipment_id']
                    }
                  },
                  {
                    join: 's:voc_volumes_washings',
                    as:   'vvw',
                    on: {
                      $eq: ['vvw.id', 'spw.washing_id']
                    }
                  },
                  {
                    join: 's:washings',
                    as:   'w',
                    on: {
                      $eq: ['w.id', 'vvw.washing_id']
                    }
                  },
                  {
                    join: 's:voc_washing_types',
                    as:   'vwt',
                    on: {
                      $eq: ['vwt.id', 'w.type_id']
                    }
                  },
                  {
                    join: 's:voc_detergents',
                    as: 'vd',
                    on: {
                      $eq: ['vd.id', 'w.detergent_id']
                    }
                  }
                ],
                order: [
                  {$asc: ['sjw.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`spw.shift_id`, {$: documentId}]},
                    // {$null: [`spv.deleted_at`]}
                  ]
                }
              }),
              vm.$q(GET_SCHEMA_FACT_VDP)
              .raw('schemas.get')
              .action({
                  id: `s:shift_journal_vdp`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_FACT_VDP);
            const opWashResult = result.getOperation(GET_SHIFT_FACT_WASH);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.type = 'atom'
                item.ingredients.map((ing: any) => {
                  if (!ing.code) {
                    return;
                  }
                  const idxs = state.ingredients.reduce((prev: any, ing: any, idx: number) => {
                    if (!prev[ing.code]) {
                      prev[ing.code] = idx 
                    }
                    return prev
                  }, {})
                  if (idxs[ing.code] == undefined) {
                    state.ingredients.push({code: ing.code, name: ing.name, id:ing.id, ingredient_id: ing.ingredient_id})
                  }
                  item[ing.code] = ing.value
                  item[ing.code + '-batch'] = ing
                })
                return item
              }).map((item: any) =>{
                state.ingredients.map((ing: any) => {
                  if (!item[ing.code]) {
                    item[ing.code] = null
                    item[ing.code + '-batch'] = {}
                  }
                })
                return item
              })
              state.relatedFactsList.push(...opWashResult.getContent().documents.map((doc: any) => {
                doc.type = 'wash'
                return doc
              }))
            }
            const opRelSchema = result.getOperation(GET_SCHEMA_FACT_VDP);
            if (!opRelSchema.hasError()) {
              state.meta = fetchEnumsFromSchema(opRelSchema.getContent().schema)
            }

            commit('LOADED_SUCCESS');
            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>№ партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Наименование ГП</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Масса сгустков, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Ведра, шт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Палет, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Масса сгустков с оборудования, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Переработка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Общая загрузка, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН 1 измерение</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН 2 измерение</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН 3 измерение</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН 4 измерение</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Выпуск ГП</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Качество ПП при загрузке</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Густота продукта во время варки</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Консистенция продукта на розливе</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время, когда сформировали партию для варки</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время начала загрузки ведер с ПП в АТОМ</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время начала розлива</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время окончания розлива партии НГП</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время постановки партии НГП под вентиляторы</td>
</tr>
{{#facts.documents}}
  <tr height="auto">
    <td wrap border base >{{number}}</td>
    <td wrap border base type=number round align=center>{{product_name}}</td>
    <td wrap border base align=center>{{clots_weight}}</td>
    <td wrap border base type=number round align=center>{{quantity}}</td>
    <td wrap border base type=number round align=center>{{palet_weight}}</td>
    <td wrap border base type=number round align=center>{{clots_device_weight}}</td>
    <td wrap border base type=number round align=center>{{recast}}</td>
    <td wrap border base type=number round align=center>{{total_weight}}</td>
    <td wrap border base type=number round align=center>{{acidity_1}}</td>
    <td wrap border base type=number round align=center>{{acidity_2}}</td>
    <td wrap border base type=number round align=center>{{acidity_3}}</td>
    <td wrap border base type=number round align=center>{{acidity_4}}</td>
    <td wrap border base align=center>{{release_name}}</td>
    <td wrap border base align=center>{{quality_name}}</td>
    <td wrap border base align=center>{{density_name}}</td>
    <td wrap border base type=date align=center>{{consitency_name}}</td>
    <td wrap border base type=date align=center>{{formed_date}}</td>
    <td wrap border base type=date align=center>{{load_pp_begin_date}}</td>
    <td wrap border base type=date align=center>{{bottling_begin_date}}</td>
    <td wrap border base type=date align=center>{{bottling_end_date}}</td>
    <td wrap border base type=date align=center>{{set_fan_date}}</td>
  </tr>
{{/facts.documents}}
</table>
                `,
                queries: {
                  facts: {
                    columns: {
                      id: 'sja.id',
                      plan_id: 'sja.plan_id',
                      number: 'sacp.number',
                      product_name: 'pp.name',
                      clots_weight: 'sja.clots_weight',
                      quantity: 'sacpi.quantity',
                      palet_weight: 'sja.palet_weight',
                      recast: { $mul: ['sja.recast', 'vcnt.weight']},
                      acidity_1: 'sja.acidity_1',
                      acidity_2: 'sja.acidity_2',
                      acidity_3: 'sja.acidity_3',
                      acidity_4: 'sja.acidity_4',
                      release_name: 'vrg.name',
                      quality_name: 'vqp.name',
                      density_name: 'vd.name',
                      consitency_name: 'vc.name',
                      clots_device_weight: 'sja.clots_device_weight',
                      formed_date: "sja.formed_date",
                      load_pp_begin_date: "sja.load_pp_begin_date",
                      bottling_begin_date: "sja.bottling_begin_date",
                      bottling_end_date: "sja.bottling_end_date",
                      set_fan_date: "sja.set_fan_date",
                      ingredients: {
                        $array_agg: {
                          $obj: {
                            id: 'sjai.id',
                            ingredient_id: 'sjai.ingredient_id',
                            name: 'vi.name',
                            code: 'vi.code',
                            value: 'sjai.value',
                            shift_atom_batch_id: 'sab.id',
                            manufacturer: 'vm.name',
                            batch_datetime: 'b.datetime',
                            batch_number: 'b.batch_number',
                          }
                        }
                      }
                    },
                    from: 's:shift_journal_atom',
                    from_as: 'sja',
                    joins: [
                      {
                        join: 's:shift_atom_coock_plan',
                        type: 'left',
                        as:   'sacp',
                        on: {
                          $eq: ['sja.plan_id', 'sacp.id']
                        }
                      },
                      {
                        join: 's:produced_products',
                        type: 'left',
                        as:   'pp',
                        on: {
                          $eq: ['sacp.product_id', 'pp.id']
                        }
                      },
                      {
                        join: 's:voc_release_gps',
                        type: 'left',
                        as:   'vrg',
                        on: {
                          $eq: ['sja.release_id', 'vrg.id']
                        }
                      },
                      {
                        join: 's:voc_quality_pps',
                        type: 'left',
                        as:   'vqp',
                        on: {
                          $eq: ['sja.quality_id', 'vqp.id']
                        }
                      },
                      {
                        join: 's:voc_densities',
                        type: 'left',
                        as:   'vd',
                        on: {
                          $eq: ['sja.density_id', 'vd.id']
                        }
                      },
                      {
                        join: 's:voc_consistencies',
                        type: 'left',
                        as:   'vc',
                        on: {
                          $eq: ['sja.consitency_id', 'vc.id']
                        }
                      },
                      {
                        join: 's:voc_containers',
                        type: 'left',
                        as:   'vcnt',
                        on: {
                          $eq: ['sja.recast_container_id', 'vcnt.id']
                        }
                      },
                      {
                        join: 's:shift_journal_atom_ingredients',
                        type: 'left',
                        as:   'sjai',
                        on: {
                          $eq: ['sjai.journal_id', 'sja.id']
                        }
                      },
                      {
                        join: 's:voc_ingredients',
                        type: 'left',
                        as:   'vi',
                        on: {
                          $eq: ['sjai.ingredient_id', 'vi.id']
                        }
                      },
                      {
                        join: 's:shift_atom_batches',
                        type: 'left',
                        as:   'sab',
                        on: {
                          $eq: ['sab.journal_ingredient_id', 'sjai.id']
                        }
                      },
                      {
                        join: 's:batches',
                        type: 'left',
                        as:   'b',
                        on: {
                          $and: [
                            {$eq: ['b.id', 'sab.batch_id']},
                            {$eq: ['b.ingredient_id', 'vi.id']}
                          ]
                        }
                      },
                      {
                        join: 's:voc_manufacturers',
                        type: 'left',
                        as:   'vm',
                        on: {
                          $eq: ['vm.id', 'b.manufacturer_id']
                        }
                      },
                      {
                        join: {
                          columns: {
                            coock_plan_id: 'sacpi.coock_plan_id',
                            quantity: {$sum: 'sacpi.quantity'}
                          },
                          from: 's:shift_atom_coock_plan_items',
                          from_as: 'sacpi',
                          groups: [
                            'sacpi.coock_plan_id'
                          ]
                        },
                        type: 'left',
                        as: 'sacpi',
                        on: { $eq: ['sacp.id', 'sacpi.coock_plan_id'] }
                      }
                    ],
                    order: [
                      {$asc: ['sacp.number']},
                    ],
                    page_size: 10000,
                    groups: [
                      "sja.id",
                      'sacp.id',
                      'pp.name',
                      'vrg.name',
                      'vqp.name',
                      'vd.name',
                      'vc.name',
                      'sacpi.quantity',
                      'vcnt.weight'
                    ],
                    where: {
                      $and: [
                        {$eq: [`sacp.shift_id`, {$: documentId}]},
                        {$null: [`sacp.deleted_at`]}
                      ]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    },

    saveShiftBatch({state}, {journal_ingredient_id, batch_id}) {
      console.log('saveShiftBatch => ', journal_ingredient_id, batch_id);
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        const saveQuery = vm.$q('SHIFT_ATOM_BATCHES_SAVE')
          .create('s:shift_atom_batches', {
            journal_ingredient_id: journal_ingredient_id,
            batch_id: batch_id,
          })
        vm.$db([
          saveQuery
        ]).then((result: ServerResult) => {
          const operationResult = result.getOperation('SHIFT_ATOM_BATCHES_SAVE');

          if (operationResult.hasError()) {
            reject('operationResult.getContent()');
          } else {
            resolve(operationResult.getContent());
          }
        })
          .catch((error: any) => {
            console.error('errror', error)
            reject(error);
          });
      })
    }
};

export const mutations: MutationTree<ShiftAtomJournalState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftAtomJournalState, RootState> = {
  exportData(state: ShiftAtomJournalState) {
    const csvContent: any[] = [];
    const headers = {
      'product_name': {label: 'Наименование ГП', format: null},
      'clots_weight': {label: 'Масса сгустков, кг', format: null},
      'quantity': {label: 'Ведра, шт', format: 'num'},
      'palet_weight': {label: 'Палет, кг', format: 'num'},
      'ingredients': {label: null, format: null},
      'clots_device_weight': {label: 'Масса сгустков с оборудования, кг', format: 'num'},
      'recast': {label: 'Переработка', format: 'num'},
      'total_weight': {label: 'Общая загрузка, кг', format: 'num'},
      'acidity_1': {label: 'рН 1 измерение', format: 'num'},
      'acidity_2': {label: 'рН 2 измерение', format: 'num'},
      'acidity_3': {label: 'рН 3 измерение', format: 'num'},
      'acidity_4': {label: 'рН 4 измерение', format: 'num'},
      'release_name': {label: 'Выпуск ГП', format: null},
      'quality_name': {label: 'Качество ПП при загрузке', format: null},
      'density_name': {label: 'Густота продукта во время варки', format: null},
      'consitency_name': {label: 'Консистенция продукта на розливе', format: null},
      'formed_date': {label: 'Время, когда сформировали партию для варки', format: 'date'},
      'load_pp_begin_date': {label: 'Время начала загрузки ведер с ПП в АТОМ', format: 'date'},
      'bottling_begin_date': {label: 'Время начала розлива', format: 'date'},
      'bottling_end_date': {label: 'Время окончания розлива партии НГП', format: 'date'},
      'set_fan_date': {label: 'Время постановки партии НГП под вентиляторы', format: 'date'},
    }
    const header = [
      ''
    ]

    const format = (value: any, format: any) => {
      switch (format) {
        case 'date':
          // @ts-ignore
          value = moment(value).format('DD.MM.YYYY HH:mm');
          break;
        case 'num':
          // @ts-ignore
          value = numeral(value).format('0,0.00');
          break;
      }
      return value;
    }

    state.relatedFactsList.map((item: any, idx: number) => {
      const row: any[] = [];
      const keys = Object.keys(headers);
      header.push(item.number)
      if (idx === 0) {
        keys.map((key: string) => {
          if (key !== 'ingredients') {
          // @ts-ignore
            csvContent.push([headers[key].label, format(item[key], headers[key].format)])
          } else {
            state.ingredients.map((ing: any) => {
              csvContent.push([ing.name, format(item[ing.code], 'num')])
            })
          }
        })
      } else {
        const _flag = {before: true}
        keys.map((key: string, row_id: number) => {
          row_id += (!_flag.before ? state.ingredients.length - 1 : 0);
          if (key !== 'ingredients') {
          // @ts-ignore
            csvContent[row_id].push(format(item[key], headers[key].format))
          } else {
            _flag.before = false;
            state.ingredients.map((ing: any, idx_idx: number) => {
              csvContent[row_id + idx_idx].push(format(item[ing.code], 'num'))
            })
          }
        })
      }
    })

    return [
        header,
        ...csvContent
    ]
  },
  totals : (state: ShiftAtomJournalState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  rotateJournal: (state: ShiftAtomJournalState) => {
    const journal = state.relatedFactsList.reduce((prev: any, item: any) => {
      Object.keys(item).map((key: any) => {
        if (!prev[key]){
          prev[key] = [];
        }
        prev[key].push(item[key]);
      })
      const total_weight = parseFloat(item.clots_weight) * ( parseFloat(item.clots_weight) < 1000 ? 1000 : 1) + state.ingredients.reduce((prev: any, ing: any) => {
        if (item[ing.code] && !ing.is_composite) {
          prev += parseFloat(item[ing.code])
        }
        return prev
      }, 0)
      prev.total_weight.push(total_weight);
      prev.rows.push(item)
      return prev
    }, {rows: [], total_weight: []})

    return journal;
  }
};

export const STORE_KEY = '$_shift_atom_journal_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
